import { render, staticRenderFns } from "./VxCellTextCopy.vue?vue&type=template&id=00ed9b03&scoped=true&"
import script from "./VxCellTextCopy.vue?vue&type=script&lang=js&"
export * from "./VxCellTextCopy.vue?vue&type=script&lang=js&"
import style0 from "./VxCellTextCopy.vue?vue&type=style&index=0&id=00ed9b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed9b03",
  null
  
)

export default component.exports